export default __webpack_public_path__ + "static/media/q7_step4.e5c7401d.png";